window.mediaBanner = () => {
    return {
        open: false,

        scrollOutOfView() {
            // Get the height of the banner and scroll until it's out of view
            const banner = document.querySelector('.Media__Banner');
            const bannerHeight = banner.getBoundingClientRect().height;
            window.scrollBy({
                top: bannerHeight,
                behavior: 'smooth'
            });
        },

        openVideo() {
            this.open = true;
        
            // Play the video after the modal is shown
            this.$nextTick(() => {
                const videoPlayer = this.$refs.modalVideoPlayer;
                const mobileVideoPlayer = this.$refs.modalVideoPlayerMobile;
        
                // First, check if the mobile video player exists and handle accordingly
                if (mobileVideoPlayer) {
                    if (mobileVideoPlayer.tagName === 'IFRAME') {
                        const src = mobileVideoPlayer.src;
        
                        // Handle YouTube or Vimeo embeds for mobile
                        if (src.includes('youtube.com')) {
                            mobileVideoPlayer.src = this.updateYouTubeURL(src, true);
                        } else if (src.includes('vimeo.com')) {
                            const player = new Vimeo.Player(mobileVideoPlayer);
                            player.setVolume(1);
                            player.play();
                        }
                    } else {
                        // Handle standard video element for mobile
                        mobileVideoPlayer.muted = false;
                        mobileVideoPlayer.volume = 1;
                        mobileVideoPlayer.play();
                    }
                }
        
                // If mobile video player doesn't exist, check for the desktop video player
                if (videoPlayer) {
                    if (videoPlayer.tagName === 'IFRAME') {
                        const src = videoPlayer.src;
        
                        // Handle YouTube or Vimeo embeds for desktop
                        if (src.includes('youtube.com')) {
                            videoPlayer.src = this.updateYouTubeURL(src, true);
                        } else if (src.includes('vimeo.com')) {
                            const player = new Vimeo.Player(videoPlayer);
                            player.setVolume(1);
                            player.play();
                        }
                    } else {
                        // Handle standard video element for desktop
                        videoPlayer.muted = false;
                        videoPlayer.volume = 1;
                        videoPlayer.play();
                    }
                }
            });
        },        

        closeVideo() {
            this.open = false;
            const videoPlayer = this.$refs.modalVideoPlayer;
            const mobileVideoPlayer = this.$refs.modalVideoPlayerMobile;
        
            // Check and pause the mobile video player if it exists
            if (mobileVideoPlayer) {
                if (mobileVideoPlayer.tagName === 'IFRAME') {
                    if (mobileVideoPlayer.src.includes('youtube.com')) {
                        mobileVideoPlayer.src = this.updateYouTubeURL(mobileVideoPlayer.src, false);
                    } else if (mobileVideoPlayer.src.includes('vimeo.com')) {
                        const player = new Vimeo.Player(mobileVideoPlayer);
                        player.pause();
                    }
                } else {
                    mobileVideoPlayer.pause();
                }
            }
        
            // If mobile video player doesn't exist, check for the desktop video player
            if (videoPlayer) {
                if (videoPlayer.tagName === 'IFRAME') {
                    if (videoPlayer.src.includes('youtube.com')) {
                        videoPlayer.src = this.updateYouTubeURL(videoPlayer.src, false);
                    } else if (videoPlayer.src.includes('vimeo.com')) {
                        const player = new Vimeo.Player(videoPlayer);
                        player.pause();
                    }
                } else {
                    videoPlayer.pause();
                }
            }
        },

        updateYouTubeURL(src, autoplay) {
            const url = new URL(src);
            const params = url.searchParams;

            params.set('autoplay', autoplay ? '1' : '0');
            params.set('mute', '0'); // Set mute to 0 to ensure unmuted playback

            return url.toString();
        }
    };
};


window.videoPlayer = () => {
    return {
        paused: true,
        videoPlayer: null,
        isYoutube: false,
        isVimeo: false,

        init() {
            this.videoPlayer = this.$el.querySelector('video');

            if (this.videoPlayer !== null && typeof this.videoPlayer !== 'undefined') {
                this.videoPlayer.addEventListener('play', () => {
                    this.paused = false;
                });

                this.videoPlayer.addEventListener('pause', () => {
                    this.paused = true;
                });

                this.videoPlayer.addEventListener('ended', () => {
                    this.paused = true;
                });
            }

            if (typeof this.$el.querySelectorAll('.video-embed') !== "undefined" && this.$el.querySelectorAll('.video-embed') !== null && this.$el.querySelectorAll('.video-embed').length) {
                const iframe = this.$el.querySelector('.video-embed iframe');
                if (iframe.src.includes('vimeo')) {
                    this.isVimeo = true;
                } else {
                    this.isYoutube = true;
                }
            }
        },

        playVideo() {
            this.paused = false;

            if (this.isYoutube) {
                const iframe = this.$root.querySelector('.video-embed iframe');
                const currentSrc = iframe.src;
                const videoID = this.extractYouTubeVideoID(currentSrc);
                
                // Update the src URL with autoplay, loop, and playlist
                const newSrc = `${currentSrc.split('?')[0]}?autoplay=1&loop=1&playlist=${videoID}&controls=0`;

                // Set the new source URL with the loop parameters
                iframe.src = newSrc;
            } else if (this.isVimeo) {
                this.playVimeo(this.$root.querySelector('.video-embed iframe'));
            } else {
                const video = this.$root.querySelectorAll('video')[0];
                video.play();
            }
        },

        playVimeo(el) {
            this.paused = false;
            const player = new Vimeo.Player(el);
            player.play();
            // Set player options for controls visibility
            player.setVolume(0);
            player.setControls(false);
        },

        pauseVimeo(el) {
            this.paused = true;
            const player = new Vimeo.Player(el);
            player.pause();
        },

        // Helper function to extract YouTube video ID
        extractYouTubeVideoID(url) {
            const regex = /[\\?\\&]v=([^\\?\\&]+)/;
            const matches = url.match(regex);
            return matches ? matches[1] : null;
        }
    }
}
